import { useState, useRef, useEffect, useCallback } from "react";
import api from "api/api";

import Select from "react-select";

// mui component
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

// icon
import CloseIcon from "@mui/icons-material/Close";

import { useSelector, useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";
//Props Validations
import PropTypes from "prop-types";

import RespondentSettingsData from "../../utils/RespondentSettingsData";
import respondentSettingsUtils from "../../utils/respondentSettingsUtils"; // Import the utility

function SettingsAddUpdate({ title = "", type = "", selectedRows = {}, isOpen = false, setIsAddDialogOpen = () => {}, setIsUpdateDialogOpen = () => {}, fetchData = () => {}, uniqueBackendVariableList = [], productCategoryLabel = null }) {
    const dispatch = useDispatch();

    const addGraph = [{ value: "TABLE", label: "Table" }];
    const genderGraph = [{ value: "DEFAULT", label: "Default" }];
    const selectInputRef = useRef();

    // add dialog confirmation
    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);

    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    const [data, setData] = useState({
        backend_variable: null,
        display_label: null,
        variable_category: null,
        active: true,
        type_of_graph: null,
        type_of_variable: null,
        product_category: productCategoryId,
    });

    // Get filtered types_of_variable based on product category using the utility function
    const getFilteredOptions = useCallback(() => {
        return respondentSettingsUtils(productCategoryLabel);
    }, [productCategoryLabel]);

    //dropdown options
    const [typeOfGraphOptions, setTypeOfGraphOptions] = useState(RespondentSettingsData.types_of_graph);
    const [typeOfVariableOptions, setTypeOfVariableOptions] = useState(getFilteredOptions());
    // dropdown selected data
    const [selectedBackendVariable, setSelectedBackendVariable] = useState(null);
    const [selectedDisplayLabel, setSelectedDisplayLabel] = useState(null);
    const [selectedTypeOfGraph, setSelectedTypeOfGraph] = useState(null);
    const [selectedTypeOfVariable, setSelectedTypeOfVariable] = useState(null);

    // Update typeOfVariableOptions when productCategoryLabel changes
    useEffect(() => {
        setTypeOfVariableOptions(getFilteredOptions());
    }, [productCategoryLabel, getFilteredOptions]);

    const setUpdatedData = () => {
        if (type === "update") {
            setData({
                backend_variable: selectedRows?.backend_variable,
                display_label: selectedRows?.display_label,
                variable_category: selectedRows?.variable_category,
                active: selectedRows?.active,
                type_of_graph: selectedRows?.type_of_graph,
                type_of_variable: selectedRows?.type_of_variable,
                product_category: selectedRows?.product_category,
            });
            const selected_obj = uniqueBackendVariableList.filter((ele) => ele["backend_variable"] === selectedRows?.backend_variable);
            if (selected_obj?.[0]) {
                setSelectedBackendVariable({
                    label: selected_obj?.[0].backend_variable,
                    value: selected_obj?.[0].backend_variable,
                });
                setSelectedDisplayLabel({
                    label: selected_obj?.[0].display_label,
                    value: selected_obj?.[0].display_label,
                });
                if (selectedRows?.type_of_graph?.toUpperCase() === "DEFAULT" || selectedRows?.type_of_graph?.toUpperCase() === "TABLE") {
                    const obj = {
                        label: selectedRows?.type_of_graph,
                        value: selectedRows?.type_of_graph,
                    };
                    setSelectedTypeOfGraph(obj);
                } else {
                    setSelectedTypeOfGraph(RespondentSettingsData.types_of_graph.filter((ele) => ele.value === selectedRows?.type_of_graph));
                }
                if (selectedRows?.type_of_variable?.toUpperCase() === "ADDITIONAL_PRODUCT_PERFORMANCE") {
                    setTypeOfGraphOptions(addGraph);
                } else {
                    setTypeOfGraphOptions(RespondentSettingsData.types_of_graph);
                }
                const filteredOptions = getFilteredOptions();
                setSelectedTypeOfVariable(filteredOptions.filter((ele) => ele.value === selectedRows?.type_of_variable));
            }
        }
    };

    useEffect(() => {
        setUpdatedData();
    }, []);

    const handleReset = () => {
        selectInputRef?.current?.clearValue();
        if (type === "add") {
            setData({
                backend_variable: null,
                display_label: null,
                variable_category: null,
                active: true,
                type_of_graph: null,
                type_of_variable: null,
                product_category: productCategoryId,
            });
            setSelectedBackendVariable(null);
            setSelectedDisplayLabel(null);
            setSelectedTypeOfGraph(null);
            setSelectedTypeOfVariable(null);
            setTypeOfGraphOptions(RespondentSettingsData.types_of_graph);
        } else if (type === "update") {
            setUpdatedData();
        }
        setTypeOfVariableOptions(getFilteredOptions());
    };
    const handleSave = () => {
        const isValid = validateInputs();
        if (isValid) {
            let payload = {
                ...data,
                title: data.backend_variable,
            };
            if (type === "add") {
                if (productCategoryId) {
                    payload = {
                        ...payload,
                        product_category: productCategoryId,
                    };
                    try {
                        const url = process.env.REACT_APP_SERVER_PATH + `/respondent-settings/`;
                        api.post(url, payload)
                            .then(() => {
                                fetchData();
                                handleClose();
                                handleConfirmationDialogClose();
                            })
                            .catch((error) => {
                                handleError("error", error);
                                handleConfirmationDialogClose();
                            });
                    } catch (error) {
                        handleError("error", error);
                        handleConfirmationDialogClose();
                    }
                } else {
                    handleError("error", "Product category is not selected");
                }
            } else if (type === "update") {
                try {
                    const url = process.env.REACT_APP_SERVER_PATH + `/respondent-settings/${selectedRows?.id}/`;
                    api.put(url, payload)
                        .then(() => {
                            fetchData();
                            handleClose();
                            handleConfirmationDialogClose();
                        })
                        .catch((error) => {
                            handleError("error", error);
                            handleConfirmationDialogClose();
                        });
                } catch (error) {
                    handleError("error", error);
                    handleConfirmationDialogClose();
                }
            }
        } else {
            handleError("error", "Incomplete inputs fields.");
        }
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const handleClose = () => {
        handleReset();
        setIsAddDialogOpen(false);
        setIsUpdateDialogOpen(false);
    };

    const validateInputs = () => {
        const hasNull = Object.values(data).some((value) => value === null || value === undefined || value === "");
        // if (data.backend_variable && data.variable_category && data.type_of_variable) {
        if (!hasNull) {
            return true;
        } else {
            return false;
        }
    };

    const handleInputValueChange = (value, type, fieldId) => {
        if (type === "dropdown") {
            const _value = value?.value;

            // Handle "backend_variable" or "display_label" field updates
            if (["backend_variable", "display_label"].includes(fieldId)) {
                if (_value) {
                    // Find the selected object from the list
                    const selectedObj = uniqueBackendVariableList.find((ele) => ele[fieldId] === _value);
                    const updatedData = { ...data };

                    if (selectedObj) {
                        // Update data with selected object values
                        updatedData["variable_category"] = selectedObj.variable_category;
                        updatedData["backend_variable"] = selectedObj.backend_variable;
                        updatedData["display_label"] = selectedObj.display_label;

                        // Update selected dropdown values
                        setSelectedBackendVariable({ label: selectedObj.backend_variable, value: selectedObj.backend_variable });
                        setSelectedDisplayLabel({ label: selectedObj.display_label, value: selectedObj.display_label });
                    }

                    // If the selected value is related to gender, update the graph type
                    if (_value?.toLowerCase() === "s_gender" || _value?.toLowerCase() === "gender") {
                        updatedData["type_of_graph"] = genderGraph[0].value;

                        setTypeOfGraphOptions(genderGraph);
                        setSelectedTypeOfGraph(genderGraph);
                    }

                    // Update the main data object
                    setData(updatedData);
                } else {
                    // Reset values when no selection is made
                    setData({
                        ...data,
                        variable_category: null,
                        backend_variable: null,
                        display_label: null,
                        type_of_graph: null,
                    });

                    setSelectedBackendVariable(null);
                    setSelectedDisplayLabel(null);
                    setTypeOfGraphOptions(RespondentSettingsData.types_of_graph);
                    setSelectedTypeOfGraph(null);
                }
            }
            // Handle "type_of_variable" field updates
            else if (fieldId === "type_of_variable") {
                if (_value) {
                    const updatedData = { ...data, [fieldId]: _value };

                    // If the selected type is "ADDITIONAL_PRODUCT_PERFORMANCE", set the graph type to "TABLE"
                    if (_value?.toUpperCase() === "ADDITIONAL_PRODUCT_PERFORMANCE") {
                        updatedData["type_of_graph"] = addGraph[0].value;

                        setTypeOfGraphOptions(addGraph);
                        setSelectedTypeOfGraph(addGraph);
                    } else {
                        // Otherwise, reset the graph type to default options
                        updatedData["type_of_graph"] = data.type_of_graph?.toUpperCase() === "DEFAULT" ? data.type_of_graph : null;
                        setTypeOfGraphOptions(data.type_of_graph?.toUpperCase() === "DEFAULT" ? genderGraph : RespondentSettingsData.types_of_graph);
                        setSelectedTypeOfGraph(data.type_of_graph?.toUpperCase() === "DEFAULT" ? genderGraph : null);
                    }

                    // Update the main data object
                    setData(updatedData);
                } else {
                    // Reset values when no selection is made
                    setData({
                        ...data,
                        [fieldId]: null,
                        type_of_graph: null,
                    });

                    setTypeOfGraphOptions(RespondentSettingsData.types_of_graph);
                    setSelectedTypeOfGraph(null);
                    setSelectedTypeOfVariable?.(null);
                }
            }
            // Handle other dropdown fields
            else {
                setData({
                    ...data,
                    [fieldId]: _value,
                });
            }
        }
        // Handle toggle switch updates
        else if (type === "toggle") {
            setData({
                ...data,
                [fieldId]: value.target.checked,
            });
        }
    };

    const handleConfirmationDialogClose = () => {
        setIsConfirmationDialogOpen(false);
    };

    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                open={isOpen}
                fullWidth={true}
                maxWidth={"md"}
            >
                <DialogTitle
                    style={{
                        backgroundColor: "rgb(51, 94, 234,0.1)",
                        color: "rgb(51, 94, 234)",
                        fontSize: 15,
                        textAlign: "center",
                        padding: "10px 12px",
                    }}
                    // className="liner-light-blue-background-2"
                    id="customized-dialog-title"
                >
                    {title}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 2,
                        color: "rgb(51, 94, 234) !important",
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <div className="row pb-2">
                        <div className="col-4">
                            <label className="input-label vertical-center text-sm ">Backend Variable :</label>
                        </div>
                        <div className="col-8">
                            <Select
                                ref={selectInputRef}
                                className="text-sm input-label-select"
                                isClearable={true}
                                isSearchable={true}
                                isDisabled={type === "update"}
                                options={uniqueBackendVariableList.map((ele) => {
                                    return {
                                        label: ele.backend_variable,
                                        value: ele.backend_variable,
                                    };
                                })}
                                value={selectedBackendVariable}
                                onChange={(datum) => {
                                    handleInputValueChange(datum, "dropdown", "backend_variable");
                                    setSelectedBackendVariable(datum);
                                }}
                                styles={{
                                    menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                        fontSize: "0.875rem",
                                        lineHeight: "1.25rem",
                                    }),
                                }}
                                menuPortalTarget={document.body}
                            />
                        </div>
                    </div>
                    <div className="row pb-2">
                        <div className="col-4">
                            <label className="input-label vertical-center text-sm ">Display Label :</label>
                        </div>
                        <div className="col-8">
                            <Select
                                ref={selectInputRef}
                                className="text-sm input-label-select"
                                isClearable={true}
                                isSearchable={true}
                                isDisabled={type === "update"}
                                options={uniqueBackendVariableList.map((ele) => {
                                    return {
                                        label: ele.display_label,
                                        value: ele.display_label,
                                    };
                                })}
                                value={selectedDisplayLabel}
                                onChange={(datum) => {
                                    handleInputValueChange(datum, "dropdown", "display_label");
                                    setSelectedDisplayLabel(datum);
                                }}
                                styles={{
                                    menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                        fontSize: "0.875rem",
                                        lineHeight: "1.25rem",
                                    }),
                                }}
                                menuPortalTarget={document.body}
                            />
                        </div>
                    </div>
                    <div className="row pb-2">
                        <div className="col-4">
                            <label className="input-label vertical-center text-sm ">
                                Variable Category :<br />
                                <span
                                    style={{
                                        fontSize: "10px",
                                        color: "grey",
                                        position: "relative",
                                        top: "-5px",
                                    }}
                                >
                                    (Read Mode)
                                </span>
                            </label>
                        </div>
                        <div className="col-8">
                            <input
                                type="text"
                                id="type"
                                disabled
                                defaultValue={data.variable_category}
                                style={{
                                    backgroundColor: type === "update" ? "#f2f2f2" : undefined,
                                    color: type === "update" ? "rgb(145, 145, 145)" : undefined,
                                }}
                                className="input-label-field text-sm"
                            />
                        </div>
                    </div>
                    <div className="row pb-2">
                        <div className="col-4">
                            <label className="input-label vertical-center text-sm ">Type of variable :</label>
                        </div>
                        <div className="col-8">
                            <Select
                                ref={selectInputRef}
                                className="text-sm input-label-select"
                                isClearable={true}
                                isSearchable={true}
                                options={typeOfVariableOptions}
                                value={selectedTypeOfVariable}
                                onChange={(datum) => {
                                    handleInputValueChange(datum, "dropdown", "type_of_variable");
                                    setSelectedTypeOfVariable(datum);
                                }}
                                styles={{
                                    menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                        fontSize: "0.875rem",
                                        lineHeight: "1.25rem",
                                    }),
                                }}
                                menuPortalTarget={document.body}
                            />
                        </div>
                    </div>
                    <div className="row pb-2">
                        <div className="col-4">
                            <label className="input-label vertical-center text-sm ">Type of graph :</label>
                        </div>
                        <div className="col-8">
                            <Select
                                ref={selectInputRef}
                                className="text-sm input-label-select"
                                isClearable={true}
                                isSearchable={true}
                                options={typeOfGraphOptions}
                                value={selectedTypeOfGraph}
                                onChange={(datum) => {
                                    handleInputValueChange(datum, "dropdown", "type_of_graph");
                                    setSelectedTypeOfGraph(datum);
                                }}
                                styles={{
                                    menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                        fontSize: "0.875rem",
                                        lineHeight: "1.25rem",
                                    }),
                                }}
                                menuPortalTarget={document.body}
                            />
                        </div>
                    </div>
                    <div className="row pb-2">
                        <div className="col-4">
                            <label className="input-label vertical-center text-sm ">Active/Retire :</label>
                        </div>
                        <div className="col-8">
                            <div
                                className=" d-flex"
                                style={{ alignItems: "center" }}
                            >
                                <Typography
                                    sx={{
                                        color: "#303030",
                                        // fontWeight: !data.active ? "700" : "400",
                                        fontSize: "14px",
                                        marginRight: "5px",
                                    }}
                                >
                                    Retire
                                </Typography>
                                <Switch
                                    size="small"
                                    checked={data.active}
                                    onChange={(e) => {
                                        handleInputValueChange(e, "toggle", "active");
                                    }}
                                />
                                <Typography
                                    sx={{
                                        fontSize: "14px",
                                        color: data.active ? "#005eef " : "unset",
                                        fontWeight: data.active ? "700" : "400",
                                        marginLeft: "5px",
                                    }}
                                >
                                    Active
                                </Typography>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="custom-btn"
                        variant="outlined"
                        size="small"
                        onClick={handleReset}
                    >
                        Reset
                    </Button>
                    <Button
                        className="custom-btn liner-light-blue-background me-3"
                        size="small"
                        autoFocus
                        variant="contained"
                        color="primary"
                        onClick={() => setIsConfirmationDialogOpen(true)}
                    >
                        {type === "add" ? "Add" : "Update"}
                    </Button>
                </DialogActions>
            </Dialog>
            {isConfirmationDialogOpen && (
                <Dialog
                    open={isConfirmationDialogOpen}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <div
                        style={{
                            padding: "10px 20px",
                            color: "rgb(92, 92, 92)",
                            backgroundColor: "rgb(51, 94, 234,0.1)",
                        }}
                    >
                        <div>
                            <p
                                style={{
                                    fontWeight: 600,
                                }}
                            >
                                {`Confirm ${type === "add" ? "adding" : "updating"} this setting.`}
                            </p>
                        </div>
                        <div>{`Are you sure you want to ${type === "add" ? "adding" : "updating"} this setting?`}</div>
                    </div>
                    <DialogActions>
                        <Button
                            className="me-2 custom-btn liner-light-blue-background"
                            size="small"
                            variant="contained"
                            color="error"
                            onClick={handleConfirmationDialogClose}
                        >
                            Disagree
                        </Button>
                        <Button
                            className="me-2 custom-btn liner-light-blue-background"
                            size="small"
                            variant="contained"
                            onClick={handleSave}
                        >
                            Agree
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}

// Typechecking props
SettingsAddUpdate.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string,
    tagsData: PropTypes.array,
    selectedRows: PropTypes.object,
    isOpen: PropTypes.bool,
    setIsAddDialogOpen: PropTypes.func,
    setIsUpdateDialogOpen: PropTypes.func,
    fetchData: PropTypes.func,
    uniqueBackendVariableList: PropTypes.array,
    productCategoryLabel: PropTypes.string,
};

export default SettingsAddUpdate;
